/* tslint:disable */
/* eslint-disable */
/**
 * Funnels API
 * API for managing funnels
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FraisTunnelListItemDto } from './FraisTunnelListItemDto';
import {
    FraisTunnelListItemDtoFromJSON,
    FraisTunnelListItemDtoFromJSONTyped,
    FraisTunnelListItemDtoToJSON,
    FraisTunnelListItemDtoToJSONTyped,
} from './FraisTunnelListItemDto';

/**
 * Frais rattachés à un tunnel.
 * @export
 * @interface GetFraisTunnelResponse
 */
export interface GetFraisTunnelResponse {
    /**
     * 
     * @type {Array<FraisTunnelListItemDto>}
     * @memberof GetFraisTunnelResponse
     */
    frais?: Array<FraisTunnelListItemDto>;
}

/**
 * Check if a given object implements the GetFraisTunnelResponse interface.
 */
export function instanceOfGetFraisTunnelResponse(value: object): value is GetFraisTunnelResponse {
    return true;
}

export function GetFraisTunnelResponseFromJSON(json: any): GetFraisTunnelResponse {
    return GetFraisTunnelResponseFromJSONTyped(json, false);
}

export function GetFraisTunnelResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetFraisTunnelResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'frais': json['frais'] == null ? undefined : ((json['frais'] as Array<any>).map(FraisTunnelListItemDtoFromJSON)),
    };
}

export function GetFraisTunnelResponseToJSON(json: any): GetFraisTunnelResponse {
    return GetFraisTunnelResponseToJSONTyped(json, false);
}

export function GetFraisTunnelResponseToJSONTyped(value?: GetFraisTunnelResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'frais': value['frais'] == null ? undefined : ((value['frais'] as Array<any>).map(FraisTunnelListItemDtoToJSON)),
    };
}

